import Axios from './Axios';

const API_URL = '/documents/categories/';

export const DocuCategories = {
  get: () => Axios.get(API_URL + `list`),
  add: (payload) => Axios.post(API_URL + 'add', payload),
  edit: (payload) => Axios.put(API_URL + 'update', payload),
  delete: (id) => Axios.delete(API_URL + id)
};